import React from 'react'
import AdminHeader from '../components/Layout/AdminHeader'
import AdminSideBar from '../components/Admin/Layout/AdminSideBar'
import AllUsers from "../components/Admin/AllUsers";

const AdminDashboardUsers = () => {
  return (
    <div className="dashboard-page-wrapper">
      <AdminHeader />
      <div className="dashboard-flex-wrapper">
        <div className="w-[80px] 800px:w-[330px] dashboard-sidebar">
          <AdminSideBar active={4} />
        </div>
        <div className="dashboard-main-content flex-1">
          <AllUsers />
        </div>
      </div>
    </div>
  )
}

export default AdminDashboardUsers